import { useQuery } from "@tanstack/react-query";
import { api } from "../../lib/api";
import type { DiscountRule, DiscountRulePatch } from "../../lib/types";
import { useCampaignMutation } from "./useCampaignMutation";

export const useDiscountRules = (campaignId: string | undefined) =>
	useQuery({
		queryKey: ["discount-rules", campaignId],
		queryFn: () => api.get<{ items: DiscountRule[] }>(`/api/campaigns/${campaignId}/discounts`),
		enabled: Boolean(campaignId),
	});

const useDiscountMutation = <TVariables>(
	campaignId: string,
	run: (variables: TVariables) => Promise<unknown>,
) => useCampaignMutation(campaignId, [["discount-rules", campaignId]], run);

export const useCreateDiscount = (campaignId: string) =>
	useDiscountMutation(campaignId, (patch: DiscountRulePatch) =>
		api.post(`/api/campaigns/${campaignId}/discounts`, patch),
	);

export const useUpdateDiscount = (campaignId: string) =>
	useDiscountMutation(campaignId, ({ ruleId, ...patch }: { ruleId: string } & DiscountRulePatch) =>
		api.put(`/api/campaigns/${campaignId}/discounts/${ruleId}`, patch),
	);

export const useDeleteDiscount = (campaignId: string) =>
	useDiscountMutation(campaignId, (ruleId: string) =>
		api.remove(`/api/campaigns/${campaignId}/discounts/${ruleId}`),
	);
